import React, { FC } from 'react';
import { createUseStyles } from 'react-jss';
import { Link } from 'react-router-dom';
import { FaUserTie as CustomerIcon } from '@react-icons/all-files/fa/FaUserTie';
import { FaRegUser as EmployeeIcon } from '@react-icons/all-files/fa/FaRegUser';
import { FaRegAddressCard as ContactIcon } from '@react-icons/all-files/fa/FaRegAddressCard';
import { FiBookmark as TicketIcon } from '@react-icons/all-files/fi/FiBookmark';
import clsx from 'clsx';
import { Result, ResultType } from '../../../../../hooks/api/useSearch';

const useStyles = createUseStyles({
  root: {
    display: 'flex',
    padding: '5px 0',
    '&:hover $text': {
      color: '#272e37',
    },
    '&:hover': {
      backgroundColor: '#f8f9fa',
    },
  },
  icon: {
    fill: '#6c757d',
    marginRight: 7,
    flexShrink: 0,
  },
  text: {
    fontSize: 14,
    color: '#6c757d',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
});

const getIconForType = (type: ResultType) => {
  switch (type) {
    case ResultType.customer:
      return CustomerIcon;
    case ResultType.contact:
      return ContactIcon;
    case ResultType.employee:
      return EmployeeIcon;
    case ResultType.ticket:
      return TicketIcon;
  }
};

interface Props {
  item: Result;
  className?: any;
  onClick: () => void;
}

const ResultItem: FC<Props> = ({ className, onClick, item }) => {
  const classes = useStyles();

  const Icon = getIconForType(item.type);

  return (
    <Link className={clsx(classes.root, className)} to={item.link} onClick={onClick}>
      <Icon className={classes.icon} size={17} />
      <span className={classes.text}>{item.text}</span>
    </Link>
  );
};

export default ResultItem;
